import { ListItem, OrderedList, Text, Box } from "@chakra-ui/react";
import { TranscriptLine } from "../insightsProduct";
import React from "react";

interface TranscriptLinesProps {
  transcriptLines: TranscriptLine[] | null;
}

const TranscriptLines: React.FC<TranscriptLinesProps> = (props) => {
  if (!props.transcriptLines) return null;

  return (
    <Box
      maxH={750}
      overflow="auto"
      borderWidth={1}
      borderRadius={5}
      padding={5}
    >
      <OrderedList spacing={2}>
        {props.transcriptLines.map((c, i) => (
          <ListItem key={i}>
            <Text>
              <Text fontWeight="bold" as="span">
                {c.speaker}
                {": "}
              </Text>
              {c.text}
            </Text>
          </ListItem>
        ))}
      </OrderedList>
    </Box>
  );
};

export default TranscriptLines;
